/* eslint-disable import/no-anonymous-default-export */
import React, { useContext } from 'react'
import styles from "./Checkout.module.css"
import { useFormik } from 'formik'
import { CartContext } from '../../Context/CartContext'
export default function () {
    let {onlinePayment , cartId} = useContext(CartContext);
    async function handleSubmit(values) {
        let response = await onlinePayment(cartId,values);
        if(response?.data?.status === "success") {
            window.location.href = response.data.session.url
        }
        console.log(response)
    } 
    let formik = useFormik({
        initialValues: {
            details:'',
            city: '',
            phone: ''
        },
        onSubmit:handleSubmit
    })
    return (
        <>
        <form onSubmit={formik.handleSubmit} className='mt-5 pt-5'>
            <label htmlFor="details">Details:</label>
            <input type="text" className='form-control mb-3' name="details" id="details"  onChange={formik.handleChange} value={formik.values.details} />

            <label htmlFor="city">City:</label>
            <input type="text" className='form-control mb-3' name="city" id="city"  onChange={formik.handleChange} value={formik.values.city} />

            <label htmlFor="phone">Phone:</label>
            <input type="text" className='form-control mb-3' name="phone" id="phone"  onChange={formik.handleChange} value={formik.values.phone} />
            <button className='btn border-main w-100' type='submit'>Pay</button>
        </form>
            <h2>Checkout</h2>
        </>
    )
}
